import { useEffect, useMemo, useState, useCallback } from "react";
import { RightWrapper } from "../../../components";
import { DataTable } from "@/components";
import { useApi, useAlert } from "@/";
import ColumnHelper from "@/utils/ColumnHelper";

import { useParams } from "react-router-dom";

const ShippingId = () => {
  const { id } = useParams();
  const { alert, AlertDialog } = useAlert();
  const [existingData, setExistingData] = useState([]);
  const { callApi } = useApi();
  const userId = id; // Replace with dynamic user ID if available

  const fetchData = useCallback(async () => {
    try {
     
      const res = await callApi(
        `/admin/customer/getShippingId?userId=${userId}`,
        "GET"
      );

      if (!res.success)
        throw new Error(res.message || "Failed to fetch shipping data");

      const shippingIds = res.data?.shippingIds || [];
      setExistingData(shippingIds);
    } catch (err) {
      console.error("Fetch error:", err);
      alert(`Failed to fetch shipping data: ${err.message || err}`);
    }
  }, [callApi, userId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "Shipping ID",
        accessorKey: "shippingId",
        meta: {
          tooltip: (row) => row.shippingId || "N/A",
        },
      }),
      ColumnHelper({
        header: "Status",
        accessorKey: "status",
        cell: (info) =>
          info.row.original.status ? (
            info.row.original.status === "Used" ? (
              <div className="inline-flex group items-center gap-1 bg-red-50/80 px-2 py-0.5 rounded-full border border-red-100">
                <div className="w-2 h-2 bg-red-500 rounded-full group-hover:animate-pulse" />
                <span className="text-xs font-medium text-red-700 tracking-wide">
                  Used
                </span>
              </div>
            ) : (
              <div className="inline-flex group items-center gap-1 bg-green-50/80 px-2 py-0.5 rounded-full border border-green-100">
                <div className="w-2 h-2 bg-green-500 rounded-full group-hover:animate-pulse" />
                <span className="text-xs font-medium text-green-700 tracking-wide">
                  Unused
                </span>
              </div>
            )
          ) : (
            <div className="inline-flex items-center gap-1.5 bg-gray-50/80 px-3 py-1.5 rounded-full border border-gray-100">
              <div className="w-2 h-2 bg-gray-500 rounded-full" />
              <span className="text-sm font-semibold text-gray-700 tracking-wide">
                N/A
              </span>
            </div>
          ),
        meta: {
          tooltip: (row) => row.status || "N/A",
        },
      }),
    ],
    []
  );

  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 m-2 pb-20 md:pb-4">
        <DataTable
          columns={columns}
          title="Shipping IDs"
          data={existingData}
          showCheckbox={false}
        />
      </div>
      <AlertDialog />
    </RightWrapper>
  );
};

export default ShippingId;
